import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";

import axios from "axios";
import { useAppContext } from "../AppContext"; // Adjust the path as needed
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { MyDomain } from "../App";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import AdminBrandsCreate from "./AdminBrandsComps/AdminBrandsCreate";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1440
        ? "50%"
        : window.innerWidth <= 1920
        ? "30%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function AdminBrandsMP() {
  const gridRef = useRef(); // Optional - for accessing Grid's API

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [Data, setData] = useState([]);
  const [height, width] = useWindowSize();
  const { User, Token } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Function to add new item received from child
  const addItemFromChild = (newItem) => {
    setData([...Data, { ...newItem, id: newItem.id }]);
  };

  const fetchData = async () => {
    console.log("aa");
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(`${MyDomain}Brands/GetAllBrands`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        //params: { Id: User.userId },
      });
      setData(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err.response.data.error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [columnDefs, setColumnDefs] = useState([
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "id",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },
    {
      flex: width > 766 ? 1 : null,
      field: "name",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "codeBrand",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) => `${params.value}`,
    },
  ]);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === Data.length ? "bottom-row" : "";
    },
    // other grid options...
  };
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    // "rag-amber-outer": function (params) {
    //   return params.value === 2004;
    // },
    // "rag-red-outer": function (params) {
    //   return params.value === 2000;
    // },
  };
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <a
          style={{
            marginTop: 20,
            fontSize: 20,
            fontWeight: 500,
          }}
        >
          Brands Page
        </a>
      </div>
      <AdminBrandsCreate onAddItem={addItemFromChild} />
      <div style={{ paddingTop: 30 }}>
        <div style={containerStyle}>
          <div style={gridStyle} className="ag-theme-alpine">
            <span style={{ color: "#1a1523", fontSize: 18 }}>
              All Brands
              {/* <span style={{ color: "#e4e2e4" }}> • </span>{" "}
            <span style={{ color: "#6f6e77" }}>{startDate}</span> */}
            </span>
            <AgGridReact
              cellClassRules={ragCellClassRules}
              ref={gridRef} // Ref for accessing Grid's API
              rowData={Data} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              onGridReady={onGridReady}
              gridOptions={gridOptions}
              suppressScrollOnNewData={true}
              getRowHeight={getRowHeight}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={10}
            />
          </div>
        </div>
        <style>
          {`
           .ag-theme-alpine .ag-root-wrapper {
             border: none;
           }
          `}
          {`
            .my-header-class {
              background-color: white;
            }
          `}
        </style>
      </div>
    </div>
  );
}
